module.exports = __webpack_public_path__ + "media/images/faq/infl8-35a022bba7d5e0b363cccc136bc334e5.png";